import React, { useState } from 'react';
import { CDBTable, CDBTableBody, CDBTableHeader, CDBBtn, CDBIcon } from 'cdbreact';
import moment from 'moment-timezone';
import { renderEstado, getDepositStatusForCuentita } from '../utils/movementHelpers';
import { fetchCycleTransactions } from '../services/depositTransactionsAPI';
import { generateDepositPDF, generateDepositExcel } from '../utils/reportGenerator';
import { formatCycleRange } from '../utils/depositCycleUtils';
import Swal from 'sweetalert2';

const MovementsTable = ({ depositos, isAccount, accessToken }) => {
    const [downloadingId, setDownloadingId] = useState(null);

    const handleDownload = async (deposito, fecha, type) => {
        const result = await Swal.fire({
            title: '¿Generar reporte?',
            text: `Se generará el reporte de depósitos en formato ${type.toUpperCase()}. ¿Deseas continuar?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, generar',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const id = isAccount && deposito.clave_rastreo !== undefined ? deposito.fi_id : deposito.id;
        setDownloadingId(id);
        try {
             // Formateamos la fecha asegurando parseo UTC si viene de la db de cuentitas/concentradora
             const isoDate = moment.utc(fecha).format(); 
             const transactions = await fetchCycleTransactions(isoDate, accessToken);
             const cycleRange = formatCycleRange(isoDate);
             
             if (type === 'pdf') {
                 generateDepositPDF(transactions, isoDate, cycleRange);
             } else {
                 generateDepositExcel(transactions, isoDate, cycleRange);
             }
        } catch (error) {
             console.error("Error generating report", error);
             alert("Error al generar el reporte: " + error.message);
        } finally {
             setDownloadingId(null);
        }
    };
    const headerStyle = {
        borderTop: '1px solid #DCDCDC',
        borderBottom: '1px solid #DCDCDC',
        backgroundColor: '#DCDCDC',
        color: '#3E4144',
    };

    const dataList = Array.isArray(depositos) ? depositos : (depositos.data || []);

    return (
        <CDBTable 
            hover 
            responsive 
            maxHeight="70vh" 
            scrollY 
            style={{ fontSize: '16px', fontFamily: 'Montserrat, sans-serif' }}
        >
            <CDBTableHeader>
                <tr>
                    <th style={headerStyle}>Fecha</th>
                    <th style={headerStyle}>Monto Depósito</th>
                    {isAccount && <th style={headerStyle}>Rastreo</th>}
                    <th style={headerStyle}>Estado</th>
                    <th style={{...headerStyle, textAlign: 'center'}}>Acciones</th>
                </tr>
            </CDBTableHeader>
            <br />
            <CDBTableBody>
                {dataList.map((deposito) => {
                    const isCuentaActual = deposito.clave_rastreo !== undefined;
                    const fecha = isCuentaActual ? deposito.spei_fechahora : deposito.date;
                    const monto = isCuentaActual ? deposito.monto : deposito.amount;
                    const claveRastreo = isCuentaActual ? deposito.clave_rastreo : '';
                    const estado = isCuentaActual ? deposito.spei_estatus : '';
                    
                    return (
                        <tr key={isCuentaActual ? deposito.fi_id : deposito.id}>
                            <td data-label="Fecha">
                                {fecha ? moment.utc(fecha).format("DD/MM/YYYY") : 'N/A'}
                            </td>
                            <td data-label="Deposito">
                                {monto ? `$${parseFloat(monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                            </td>
                            {isAccount && (
                                <td data-label="Rastreo">
                                    {isCuentaActual ? claveRastreo : ''}
                                </td>
                            )}
                            <td data-label="Estado">
                                {isCuentaActual 
                                    ? renderEstado(estado) 
                                    : renderEstado(getDepositStatusForCuentita(fecha))
                                }
                            </td>
                            <td data-label="Acciones">
                                {downloadingId === (isCuentaActual ? deposito.fi_id : deposito.id) ? (
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <CDBIcon icon="spinner" spin size="lg" />
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                        <CDBBtn color="danger" circle size="sm" onClick={() => handleDownload(deposito, fecha, 'pdf')} disabled={downloadingId !== null} style={{ height: '30px', width: '30px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <CDBIcon icon="file-pdf" size="sm" style={{ margin: 0 }} />
                                        </CDBBtn>
                                        <CDBBtn color="success" circle size="sm" onClick={() => handleDownload(deposito, fecha, 'excel')} disabled={downloadingId !== null} style={{ height: '30px', width: '30px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <CDBIcon icon="file-excel" size="sm" style={{ margin: 0 }} />
                                        </CDBBtn>
                                    </div>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </CDBTableBody>
        </CDBTable>
    );
};

export default MovementsTable;
